import axios from 'axios';
import config from 'config';
import { createApi } from 'utils/api';

const itemV1Api = axios.create({
  baseURL: config.itemV1ApiBaseUrl,
  params: {
    apikey: config.apiKey,
  },
});

const createItemV1Api = createApi(itemV1Api);
export const getItemV1Data = createItemV1Api('get');
export const patchItemV1Data = createItemV1Api('patch');
export const postItemV1Data = createItemV1Api('post');
export const putItemV1Data = createItemV1Api('put');